module.exports = __webpack_public_path__ + "static/img/winner1.5d6bad28.png";